"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AuthLayout = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _authViews = _interopRequireDefault(require("../../views/auth-views"));

var AuthLayout = function AuthLayout() {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "auth-container"
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "/clPortal",
    component: _authViews.default
  })));
};

exports.AuthLayout = AuthLayout;
var _default = AuthLayout;
exports.default = _default;